export default __webpack_public_path__ + "static/media/back_arrow.43f2e2f6.svg";